"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonToView = void 0;
var tslib_1 = require("tslib");
var view_1 = require("@catalytic/view");
var view_util_from_json_schema_catalytic_web_1 = require("@catalytic/view-util-from-json-schema-catalytic-web");
var to_json_schema_1 = (0, tslib_1.__importDefault)(require("to-json-schema"));
var unist_util_map_1 = (0, tslib_1.__importDefault)(require("unist-util-map"));
var setDefaultRole = function (node, role) {
    return (0, unist_util_map_1.default)(node, function (node) {
        node.role = node.role || role;
        return node;
    });
};
function jsonToView(value, options) {
    var _a = (options || {}).defaultRole, defaultRole = _a === void 0 ? view_1.Role.READER : _a;
    return setDefaultRole((0, view_util_from_json_schema_catalytic_web_1.jsonSchemaToView)((0, to_json_schema_1.default)(value)), defaultRole);
}
exports.jsonToView = jsonToView;
//# sourceMappingURL=parse.js.map